import React from 'react'
import { Route, Switch } from 'react-router'
import styled from 'styled-components'
import { rem } from 'polished'
import { BUSINESS_TRAVELLER_ROOT_ROUTE } from 'components/App/Routes/routeConstants'

const ReservedAppFooterSpace = styled.div<{ $height: number }>`
  height: calc(${({ $height }) => rem($height)} + ${props => props.theme.layout.footerFloatingOffset});
`

// Pages that have their own footer clearance
const ROUTES_WITH_OWN_NAV_CLEARANCE = [
  `/:regionCode${BUSINESS_TRAVELLER_ROOT_ROUTE}`, // landing page
]

// Routes that would have a small reserved space at the bottom of the page (e.g. upcoming bookings page)
const ROUTES_WITH_SMALL_RESERVED_SPACE = [
  '/:regionCode/account/my-bookings/order/:orderId', // My bookings page
  '/:regionCode/account/my-bookings/:tab(upcoming)?', // Manage My booking page
]

// Routes that would have a large reserved space at the bottom of the page (e.g. offer page)
const ROUTES_WITH_LARGE_RESERVED_SPACE = [
  '/:regionCode/offer/:offerId', // single offer page
  '/:regionCode/offer/:offerSlug/:offerId',
  '/:regionCode/partner/:offerSlug/:offerId', // bedbank offer page
]

/**
 * The mobile app reserves some space at the bottom of the page
 */
function AppFooterRoutes() {
  return (
    <Switch>
      <Route exact path={ROUTES_WITH_OWN_NAV_CLEARANCE} />
      <Route exact path={ROUTES_WITH_SMALL_RESERVED_SPACE}>
        <ReservedAppFooterSpace $height={75} aria-hidden="true" data-testid="app-footer-reserved-space" />
      </Route>
      <Route exact path="/:regionCode/account/details">
        <ReservedAppFooterSpace $height={110} aria-hidden="true" data-testid="app-footer-reserved-space" />
      </Route>
      <Route path={ROUTES_WITH_LARGE_RESERVED_SPACE}>
        <ReservedAppFooterSpace $height={110} aria-hidden="true" data-testid="app-footer-reserved-space" />
      </Route>
      <Route>
        <ReservedAppFooterSpace $height={0} aria-hidden="true" data-testid="app-footer-reserved-space" />
      </Route>
    </Switch>
  )
}

export default AppFooterRoutes
